import * as THREE from 'three'
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js'

export function addAxes(scene: THREE.Scene, integerPoints: THREE.Vector3[]): void {
  const color = 0xbbbbbb
  const opacity = 0.8

  const createAxis = (dir: THREE.Vector3, label: string) => {
    const normDir = dir.clone().normalize()
    let length = 2
    if (integerPoints.length > 0) {
      const maxCoord = Math.max(...integerPoints.map(p => p.dot(dir)))
      length = Math.max(2, maxCoord + 1.25)
    }

    const axisGroup = new THREE.Group()
    axisGroup.name = 'axis-group'

    const lineMaterial = new THREE.LineBasicMaterial({
      color,
      transparent: true,
      opacity,
      depthTest: false,
    })
    const lineGeometry = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(0, 0, 0),
      normDir.clone().multiplyScalar(length),
    ])
    const line = new THREE.Line(lineGeometry, lineMaterial)
    line.renderOrder = -1

    const coneGeometry = new THREE.ConeGeometry(0.03, 0.18, 16)
    const coneMaterial = new THREE.MeshBasicMaterial({ color, transparent: true, opacity, depthTest: false })
    const arrowhead = new THREE.Mesh(coneGeometry, coneMaterial)
    arrowhead.position.copy(normDir.clone().multiplyScalar(length))
    arrowhead.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), normDir)
    arrowhead.renderOrder = -1

    axisGroup.add(line)
    axisGroup.add(arrowhead)
    scene.add(axisGroup)

    if (typeof document !== 'undefined') {
      const labelDiv = document.createElement('div')
      labelDiv.className = 'axis-label'
      labelDiv.textContent = label
      labelDiv.style.color = '#dddddd'
      labelDiv.style.fontSize = '20px'
      labelDiv.style.fontFamily = 'serif'
      labelDiv.style.fontStyle = 'italic'
      labelDiv.style.fontWeight = '500'
      labelDiv.style.textShadow = '0 0 3px black'

      const labelObj = new CSS2DObject(labelDiv)
      labelObj.position.copy(normDir.clone().multiplyScalar(length + 0.25))
      scene.add(labelObj)
    }
  }

  createAxis(new THREE.Vector3(1, 0, 0), 'x')
  createAxis(new THREE.Vector3(0, 1, 0), 'y')
  createAxis(new THREE.Vector3(0, 0, 1), 'z')
}
